/*
 * Public API Surface of kraken-icon-button
 */

export * from './lib/kraken-icon-button.service';
export * from './lib/kraken-icon-button.component';
export * from './lib/kraken-icon-button.module';
